import { z } from 'zod';

import { idSchema } from './id';

// Mirrors GET /job-architectures/{id}/comments/statistics. `open` counts threads created in the window that
// are still unresolved; `resolved` counts threads resolved in the window, even when created earlier.
export const commentCountsSchema = z.object({
    comments: z.number().int().nonnegative(),
    open: z.number().int().nonnegative(),
    replies: z.number().int().nonnegative(),
    resolved: z.number().int().nonnegative(),
});

export const commentStatisticsItemSchema = z.object({
    counts: commentCountsSchema,
    id: idSchema,
    parentId: idSchema.nullish(),
    title: z.string(),
    type: z.enum(['level', 'role']),
});

export const commentStatisticsSchema = z.object({
    from: z.iso.datetime().nullish(),
    items: commentStatisticsItemSchema.array(),
    to: z.iso.datetime().nullish(),
    totals: commentCountsSchema,
});

export type CommentCounts = z.infer<typeof commentCountsSchema>;
export type CommentStatisticsItem = z.infer<typeof commentStatisticsItemSchema>;
export type CommentStatistics = z.infer<typeof commentStatisticsSchema>;
